/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Tea_Type_Duplicate_CodeInputs */

const vi_toast_tea_type_duplicate_code = /** @type {(inputs: Toast_Tea_Type_Duplicate_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã loại chè đã tồn tại`)
};

/**

* @param {Toast_Tea_Type_Duplicate_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_tea_type_duplicate_code = /** @type {((inputs?: Toast_Tea_Type_Duplicate_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Tea_Type_Duplicate_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_tea_type_duplicate_code(inputs)
});